import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ComponentFactory } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestModalModule } from './testing';

/**
 * Components
 */

import { ModalComponent } from '.';
import { OverlayComponent } from './overlay';

/**
 * Services
 */

import { 
  ModalService,
  ComponentResolverService,
} from './services';
export class ModalModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    TestModalModule
  ],
  declarations: [
    ModalComponent,
    OverlayComponent
  ],
  entryComponents: [
    OverlayComponent
  ],
  providers: [
    ModalService,
    ComponentResolverService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    ModalComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalModule_tsickle_Closure_declarations() {
/** @type {?} */
ModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
